module.exports = __webpack_public_path__ + "static/media/soundcloud.664f316b.png";